import Pusher from 'pusher-js'

const key = process.env.VUE_APP_PUSHER_KEY
const cluster = process.env.VUE_APP_PUSHER_CLUSTER || 'us2'

let pusher = null
if (key) {
  pusher = new Pusher(key, { cluster })
}

export default pusher
